export default __webpack_public_path__ + "static/media/news-six3.c09b2ee6.jpg";